import React from "react";
import GroupSchoolAdminListSection from "./components/list";

/**
 * GroupSchoolAdmin Module
 *
 * Main component for the Feedbacks module that displays a list of feedbacks
 * and provides navigation to add new feedbacks.
 */
const GroupSchoolAdmin: React.FC = () => {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Student Logs List - Takes remaining height */}
      <div className="h-full">
        <GroupSchoolAdminListSection />
      </div>
    </div>
  );
};

export default GroupSchoolAdmin;
